import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from "recharts";
import { levelFor } from "@/lib/framework";

export function TsbGauge({ tsb, tsb100, size = 200, testId }) {
  const lv = levelFor(tsb);
  const data = [{ name: "tsb", value: tsb100, fill: lv.hex }];
  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size * 0.72 }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart
          innerRadius="72%"
          outerRadius="100%"
          data={data}
          startAngle={210}
          endAngle={-30}
          barSize={16}
        >
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
          <RadialBar background={{ fill: "#e2e8f0" }} dataKey="value" cornerRadius={10} angleAxisId={0} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center pt-4">
        <span className="font-mono-num text-4xl font-bold text-[#003057]">{tsb.toFixed(2)}</span>
        <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">of 4.0</span>
        <span className="mt-1 text-sm font-semibold" style={{ color: lv.hex }}>{lv.name}</span>
      </div>
    </div>
  );
}
